/**
 * LLM connector management hooks.
 *
 * Back the user's "Connected apps" page (their own grants, with disconnect) and the
 * Connector admin page (kill switches, every grant, the audit log, registered clients).
 */
import { useCCMS } from '../useCCMS';
/** All connector services. Throws if CCMSProvider was configured without them. */
export function useConnectorServices() {
    const { services } = useCCMS();
    if (!services?.connector) {
        throw new Error('Connector services not available. Ensure CCMSProvider is configured with connector services.');
    }
    return services.connector;
}
/** The ConnectorService — grants, settings, logs and clients. */
export function useConnectorService() {
    return useConnectorServices().connector;
}
//# sourceMappingURL=useConnectorServices.js.map